export default "__VITE_ASSET__RKLoyaH$__"